import { useMediaQuery } from "react-responsive";

const useIsMobile = () => {
    const isMobile = useMediaQuery({ maxWidth: 700 });

    return isMobile;
}

export default useIsMobile;